import React, { useContext, useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaRegHeart } from 'react-icons/fa';
import { MdEdit, MdSync, MdSettings } from 'react-icons/md';
import { RiFileExcel2Line, RiImageLine } from 'react-icons/ri';
import { Tooltip, IconButton, CircularProgress } from '@material-ui/core';
import Menu from '../ModalCollection/MenuDrawer';
import ModalViewingAs from './ModalViewingAs';
import HeaderMobile from '../../componentsMobile/HeaderMobile';
import Snackbar from '../../util/SnackBar';

import FarmLogo from '../../assets/logo_farmRio.svg';

import styles from './styles.module.scss';
import globalStyles from '../../styles/global.module.scss';

import useUserContext from '../../hooks/useUserContext';
import useModalLoginContext from '../../hooks/useModalLoginContext';
import useViewAsContext from '../../hooks/useViewAsContext';
import { ProductContext } from '../../contexts/products';
import { ImagesToExportContext } from '../../contexts/imagesToExport';
import { uploadProductImages } from '../../services/api';

export default function HeaderView({
  handleShowDND,
  isCategoryDetail,
  handleExportProducts,
  handleExportImages,
}) {
  const { userState } = useUserContext();
  const [loading, setLoading] = useState(false);

  const {
    show: openModalLogin,
    hide: closeModalLogin,
  } = useModalLoginContext();

  const { show: openModalViewAs, viewAsState } = useViewAsContext();

  const { user } = userState;

  // CONTEXTO PRODUTO
  const { exported } = useContext(ProductContext);

  // CONTEXTO IMAGENS PARA EXPORTAÇÃO
  const { btnText } = useContext(ImagesToExportContext);

  const syncProductImages = useCallback(async () => {
    setLoading(true);
    await uploadProductImages();
    setLoading(false);
    return Snackbar.success('Product image have been updated');
  }, []);

  const viewAsUser = viewAsState.selectedUser;
  const isAuthenticated = Boolean(userState.token);
  const isAdmin = user.admin;

  useEffect(() => {
    if (isAuthenticated) closeModalLogin();
  }, [isAuthenticated, closeModalLogin]);

  return window.innerWidth < 1024 ? (
    <HeaderMobile />
  ) : (
    <>
      <ModalViewingAs />
      <header className={styles.header}>
        <div className={styles.left}>
          {!isAuthenticated && (
            <button
              onClick={openModalLogin}
              type="button"
              className={globalStyles.textButton}
            >
              Log In
            </button>
          )}
          {isAuthenticated && <Menu />}
        </div>
        <div className={styles.middle}>
          <Link className={globalStyles.link} to="/">
            <img
              className={styles.logo}
              src={FarmLogo}
              title="Farm Rio"
              alt="Logo Farm Rio"
            />
          </Link>
        </div>
        <div className={styles.right}>
          {!isAuthenticated && (
            <Link className={globalStyles.link} to="/register">
              Apply
            </Link>
          )}
          {isAuthenticated && (
            <>
              {!isAdmin && (
                <Link
                  to="/collection"
                  className={`${globalStyles.link} ${styles.userCollectionLink}`}
                >
                  {`${user.name}'s Collection`} <FaRegHeart />
                </Link>
              )}
              {isAdmin && (
                <div className={styles.adminActions}>
                  {((document.location.pathname.includes('category') &&
                    isCategoryDetail > 0) ||
                    document.location.pathname.includes('view')) && (
                    <Tooltip title="Edit Delivery" arrow>
                      <IconButton
                        size="small"
                        onClick={() => handleShowDND()}
                        className={styles.iconAction}
                      >
                        <MdEdit size={20} color="#000" />
                      </IconButton>
                    </Tooltip>
                  )}
                  {document.location.pathname.includes('view') && (
                    <Tooltip title={exported || 'Export spreadsheet'} arrow>
                      <IconButton
                        size="small"
                        onClick={() => handleExportProducts()}
                        className={styles.iconAction}
                      >
                        <RiFileExcel2Line size={20} color="#000" />
                      </IconButton>
                    </Tooltip>
                  )}
                  {document.location.pathname.includes('view') && (
                    <Tooltip title={btnText || 'Export images'} arrow>
                      <IconButton
                        size="small"
                        onClick={() => handleExportImages()}
                        className={styles.iconAction}
                      >
                        <RiImageLine size={20} color="#000" />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip
                    title={loading ? 'Syncing product images...' : 'Sync product images'}
                    arrow
                  >
                    <IconButton
                      size="small"
                      onClick={syncProductImages}
                      disabled={loading}
                      className={styles.iconAction}
                    >
                      {loading ? (
                        <CircularProgress size={18} style={{ color: '#000' }} />
                      ) : (
                        <MdSync size={20} color="#000" />
                      )}
                    </IconButton>
                  </Tooltip>
                  <button
                    onClick={openModalViewAs}
                    className={`${globalStyles.textButton} ${styles.viewAsButton}`}
                    type="button"
                  >
                    <span className={styles.viewAsLabel}>Viewing as</span>
                    <span className={styles.viewAsName}>
                      {viewAsUser ? viewAsUser.name : user.name}
                    </span>
                  </button>
                  <Tooltip title="Admin Panel" arrow>
                    <Link to="/admin" className={styles.iconLink}>
                      <MdSettings size={20} color="#000" />
                    </Link>
                  </Tooltip>
                </div>
              )}
            </>
          )}
        </div>
      </header>
    </>
  );
}
